import { create } from 'zustand';

export const useAssetGroupCriticalityEvaluationStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    searchParams: {
        page: 1,
        pageSize: 20,
        sortBy: 'assetGroupName',
        sortOrder: 'asc',
        search: '',
    },
    paginationData: {
        total: 0,
        totalPages: 0,
        page: 1,
        pageSize: 20,
    },
    uniqueValues: {},

    mySurveys: [],
    mySurveysLoading: false,

    dialogRow: null,
    assignExpertsOpen: false,
    startSurveyOpen: false,
    surveySummaryOpen: false,
    evaluationReviewOpen: false,
    restartOpen: false,
    surveyFillOpen: false,
    surveyFillDetail: null,

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSearchParams: (params) => set((s) => ({
        searchParams: { ...s.searchParams, ...params },
    })),
    setPaginationData: (paginationData) => set({ paginationData }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),

    setMySurveys: (mySurveys) => set({ mySurveys }),
    setMySurveysLoading: (mySurveysLoading) => set({ mySurveysLoading }),

    openAssignExperts: (row) => set({ dialogRow: row, assignExpertsOpen: true }),
    closeAssignExperts: () => set({ assignExpertsOpen: false }),

    openStartSurvey: (row) => set({ dialogRow: row, startSurveyOpen: true }),
    closeStartSurvey: () => set({ startSurveyOpen: false }),

    openSurveySummary: (row) => set({ dialogRow: row, surveySummaryOpen: true }),
    closeSurveySummary: () => set({ surveySummaryOpen: false }),

    openEvaluationReview: (row) => set({ dialogRow: row, evaluationReviewOpen: true }),
    closeEvaluationReview: () => set({ evaluationReviewOpen: false }),

    openRestart: (row) => set({ dialogRow: row, restartOpen: true }),
    closeRestart: () => set({ restartOpen: false }),

    openSurveyFill: (row, detail = null) => set({
        dialogRow: row,
        surveyFillOpen: true,
        surveyFillDetail: detail,
    }),
    closeSurveyFill: () => set({ surveyFillOpen: false, surveyFillDetail: null }),

    updateItemInList: (updated) => set((s) => ({
        items: s.items.map((item) => {
            const sameEvaluation = updated.id && item.id === updated.id;
            const sameAssetGroup = item.assetGroupId === updated.assetGroupId;
            return sameEvaluation || sameAssetGroup ? { ...item, ...updated } : item;
        }),
    })),
}));
